import styled from "styled-components";

import { COLORS, MIN_WIDTH_PAGE_PROPS } from "../../constants/Styles";
import { PROJECT_DETAILS_WIDTH } from "./ProjectDetails/ProjectDetailsStyles";

const SignInContainer = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.background};
  background-image: url("/images/vector_3.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: scroll;
  padding: 1rem;
  gap: 1rem;
`;

const PROJECT_DETAILS_GAP = "1rem";

const MAX_BODY_SIZE = `calc(100% - ${PROJECT_DETAILS_WIDTH} - ${PROJECT_DETAILS_GAP})`;

const Container = styled.div`
  gap: ${PROJECT_DETAILS_GAP};
  padding: 0 1rem;
  ${MIN_WIDTH_PAGE_PROPS};
  align-self: stretch;
  min-width: 100vw;
  justify-content: flex-end;
`;

export { SignInContainer, Container, PROJECT_DETAILS_GAP, MAX_BODY_SIZE };
